import {Box} from '@primer/react'
import {AsyncChecksStatusBadge} from './AsyncChecksStatusBadge'
import {LoadingSkeleton} from '@github-ui/skeleton/LoadingSkeleton'
import {SignedCommitBadge as UiSignedCommitBadge} from '@github-ui/signed-commit-badge'
import type {DeferredCommitData} from '../types/commits-types'
import {useCommitsAppPayload} from '../hooks/use-commits-app-payload'
import {useIsDeferredDataLoading} from '../contexts/DeferredCommitDataContext'
import type {Repository} from '@github-ui/current-repository'

export const verifiedBadgeWidth = '62px'

export function SignedCommitBadge({deferredData}: {deferredData: DeferredCommitData | undefined}) {
  const {helpUrl} = useCommitsAppPayload()
  const isLoading = useIsDeferredDataLoading()

  return (
    <>
      {isLoading && <LoadingSkeleton variant="rounded" sx={{display: ['none', 'flex'], width: verifiedBadgeWidth}} />}
      {!isLoading && deferredData && (
        <UiSignedCommitBadge
          commitOid={deferredData.oid}
          hasSignature={true}
          verificationStatus={deferredData.verifiedStatus}
          signature={{helpUrl, ...deferredData.signatureInformation!}}
        />
      )}
    </>
  )
}

export function CommitChecksStatusBadge({
  deferredData,
  oid,
  repository,
}: {
  deferredData: DeferredCommitData | undefined
  oid: string
  repository: Repository
}) {
  const isLoading = useIsDeferredDataLoading()

  let checkStatusCount = ''
  try {
    checkStatusCount = deferredData?.statusCheckStatus?.short_text?.split('checks')[0]?.trim() || ''
  } catch {
    //noop
  }

  return (
    <>
      {isLoading && <LoadingSkeleton variant="rounded" sx={{display: ['none', 'flex'], width: '20px'}} />}
      {!isLoading && deferredData?.statusCheckStatus && <Box sx={{display: ['none', 'inherit'], ml: 1}}>&middot;</Box>}
      <Box sx={{display: ['none', 'inherit']}}>
        <AsyncChecksStatusBadge
          oid={oid}
          status={deferredData?.statusCheckStatus?.state}
          descriptionString={checkStatusCount}
          repo={repository}
        />
      </Box>
    </>
  )
}

try{ SignedCommitBadge.displayName ||= 'SignedCommitBadge' } catch {}
try{ CommitChecksStatusBadge.displayName ||= 'CommitChecksStatusBadge' } catch {}